module.exports = __webpack_public_path__ + "img/cart.80355830.svg";